import {HouseQueNonMemberState} from '@houseque/core/types';
import {useSelector} from 'react-redux';

export const useAuthenticationState = () => {
  return useSelector((store: HouseQueNonMemberState) => {
    return store.authentication;
  });
};
